<!--The content below is only a placeholder and can be replaced.-->
<app-jumbotron></app-jumbotron>

<!-- <app-about></app-about> -->
<app-work></app-work>
<app-education></app-education>
<app-contact></app-contact>

<app-disclaimer></app-disclaimer>
<router-outlet></router-outlet>